import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import ArticlesService from "../Services/Articles";
import { Link, useLocation } from "react-router-dom";
import "../Styles/Articles.css";
import artimg from "../Images/atul-assets-img.png";
import i18n, { _get_i18Lang } from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import Loader from "./Loader";
import VideoService from "../Services/VideoPlayer";
import { LogInModel } from "./LoginModel";

const ArticlesDetailPage = (props: any) => {
  const [Articletcontent, setarticleContent] = useState({
    __html: "",
  });
  const { t } = useTranslation();
  const location = useLocation();
  const notificationRef = useRef<any>(null);
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const state = location.state as {
    articleId: string;
    articleName: string;
    articleSlug: string;
    authorId: string;
    authorName: string;
    authorSlug: string;
    special: string;
    index: number;
    searched: string;
  };

  const [ArticlesDetail, setArticlesDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);

  const [toggleFav, setToggleFav] = useState<boolean>(false);
  const [logIn, setLogIn] = useState<boolean>(false);
  const [articleId, setArticleId] = useState("");
  const UserIdentity = localStorage.getItem("UserId") as any;
  const [loading, setLoading] = useState(true);

  const closeModal = () => {
    setLogIn(false);
  };

  const handleLoginStateChange = (newState: any) => {
  }

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = "block";

    setTimeout(() => {
      notificationRef.current.style.display = "none";
    }, 3000); // Hide the notification after 2 seconds
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(
        !isLiked
          ? localStorage.getItem("lan") === "hindi"
            ? "अनमोल लेख को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
            : "Article has been successfully added to the favourites"
          : localStorage.getItem("lan") === "hindi"
            ? "अनमोल लेख को मेरी पसंद से हटाया गया है।"
            : "Article has been removed from favourites"
      );
    }
  };

  const toggleLike = () => {
    !isLiked
      ? ArticlesService.addArticlesFavourite(articleId).then((res) => {
        res.status && setIsLiked(true);
      })
      : ArticlesService.removeArticlesFaviourite(articleId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  function createMarkup() {
    return { __html: Articletcontent.__html };
  }

  useEffect(() => {
    if (location.state) {
      setArticleId(state?.articleId);
    }
  }, [location]);

  useEffect(() => {
    if (articleId) {
      setRefresh(false);
      const fetchData = async () => {
        try {
          const response = await ArticlesService.getArticlesDetail(
            articleId,
            UserIdentity || ""
          )
          const res = await response;
          setArticlesDetail(res?.result);
          setarticleContent({ __html: res?.result?.articleContent });
          setIsLiked(res?.result?.isFavourite);

          const currentTime = new Date().toISOString();
          const pathsegements = window.location.pathname.split("/");
          const firstParam = pathsegements[1];
          VideoService.updateUserActivity(firstParam, state?.articleId, currentTime).then((res: any) => {
          });;

        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false); // Hide loader after fetching
        }
      }
      fetchData();
    }
  }, [refresh, i18n.language, articleId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="newcontainer"
      style={{ backgroundColor: "#FFF6E1", padding: "1px 0", marginTop: 0 }}
    >
      <div
        className="breadcrumbs-head newcontainer"
        style={{
          width: "100%",
          marginTop: "-175px",
          background: "none",
          backgroundColor: "#ffedbc",
          height: "240px",
          borderBottom: "2px solid #fff",
          paddingTop: 0,
        }}
      >
        <div className="breadcrumbs">
          <div
            className="containers"
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(209, 21, 1)",
              top: "155px",
              fontFamily: "ChanakyaUni"
            }}
          >
            {window.location.pathname ===
              "/searchdata/article/" + state?.articleSlug && t("Article_tr")}
            {window.location?.pathname === "/articles/" + state?.articleSlug &&
              t("Article_tr")}
            {window.location?.pathname ===
              "/articles/special/" + state?.articleSlug &&
              t("Special_Article_tr")}
            {state?.authorId !== undefined && (
              <span>{ArticlesDetail?.author || state?.articleName}</span>
            )}
            <div
              style={{
                fontSize: "19px",
                fontWeight: 600,
                color: "#2d2a29",
                marginTop: "-8px",
              }}
            >
              <Link style={{ marginRight: "4px", color: "#2d2a29" }} to="/">
                {t("Home_tr")}
              </Link>
              {window?.location?.pathname ===
                "/articles/" + state?.articleSlug && (
                  <Link
                    to={"/articles"}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {t("Article_tr")}
                  </Link>
                )}
              {window.location?.pathname ===
                "/articles/special/" + state?.articleSlug && (
                  <Link
                    to={"/articles/special"}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {t("Special_Article_tr")}
                  </Link>
                )}
              {state?.authorId !== undefined ? (
                <>
                  <Link
                    to={"/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    / {ArticlesDetail?.author || state?.articleName}
                  </Link>
                  <Link
                    to={"/articles/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    / {t("Article_tr")}
                  </Link>
                </>
              ) : (
                ""
              )}
              <span style={{ marginRight: "8px", color: "#2d2a29" }}>
                / {ArticlesDetail?.name}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "10px" }}>
        <div>
          {ArticlesDetail ? (
            <div
              key={`articledetail-${ArticlesDetail.id}`}
              style={{ backgroundColor: "#fff6e1", padding: "1px 0px 3% 0" }}
            >
              <div
                style={{
                  backgroundColor: "rgb(255, 250, 240)",
                  boxShadow: "0 0 7px 1px #f5deb1",
                  padding: "30px 40px",
                  margin: "10px 0px",
                }}
              >
                <div className="message-header"
                  style={{
                    backgroundColor: "#fef0ce",
                    padding: "25px",
                    margin: "1% 0 4%",
                    width: "100%"
                  }}
                >
                  <div className="row">
                    <div className="col-md-2">
                      <a>
                        <img
                          src={artimg}
                          onError={(e) => {
                            e.currentTarget.src = artimg;
                          }}
                          alt={ArticlesDetail.name}
                          title={ArticlesDetail.name}
                        />
                      </a>
                    </div>
                    <div className="col-md-10">
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h1 style={{ color: "#2d2a29", fontSize: "40px", fontStyle: "normal", fontWeight: 700 }}>{ArticlesDetail.name}</h1>
                        <div
                          className="notification-bar"
                          ref={notificationRef}
                          style={{
                            color: "#ff3d28",
                            fontSize: "20px",
                            marginTop: "10px",
                            marginLeft: "40%"
                          }}
                        ></div>
                        <label
                          style={{ marginLeft: "5%" }}
                          onClick={() => {
                            if (!UserIdentity) setLogIn(true);
                          }}
                        >
                          <label
                            onClick={() => {
                              toggleLike();
                              notify();
                            }}
                          >
                            <img
                              width="45px"
                              src={isLiked ? Favfill : Favempty}
                              alt="Favicon"
                            />
                          </label>
                        </label>
                      </div>
                      <p style={{ display: ArticlesDetail?.author?.length > 0 ? "flex" : "none", borderBottom: "1px solid #ecd59f" }}>
                        <label className="label-authorname">{t("Authors_tr")}: </label>
                        <p className="p-authorname">{ArticlesDetail.author}</p>
                      </p>
                      <p style={{ borderBottom: "0", marginBottom: "0", display: ArticlesDetail?.language != null || "" ? "none" : "flex" }}>
                        <label className="label-authorname">{t("Language_tr")}: </label>
                        <p className="p-authorname">{ArticlesDetail.articleLanguage}</p>
                      </p>

                    </div>
                  </div>
                </div>
                <div>
                  <h2
                    style={{
                      color: "#ff731f",
                      margin: 0,
                      fontSize: "32px",
                      fontFamily: "ChanakyaUni",
                    }}
                  >
                    {t("Description_tr")}
                  </h2>
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontFamily: "ChanakyaUni",
                  }}
                  className="article-content content-font"
                  dangerouslySetInnerHTML={createMarkup()}
                ></div>
              </div>
            </div>
          ) : (
            <div className="ebooks-category resultnotfound">
              {loading && <Loader loading={loading} />}
              {t("result_not_found_tr")}
            </div>
          )}
        </div>
        <LogInModel
          opens={logIn}
          onCloses={closeModal}
          onLoginStateChange={handleLoginStateChange}
        />
      </div>
    </div>
  );
};
export default ArticlesDetailPage;
